export const choosesReducer = (state = {loading: true, result: null, chooses: [], choose: null, schedule: [], scheduleLoading: false, scheduleQty: 0, noteLoading: false, history: [], historyLoading: false} , action) => {
    switch (action.type) {
        case 'CHOOSE_GET_ALL_SUCCESS':
            return {
                ...state,
                loading: false,
                chooses: action.payload
            }
        case 'CHOOSE_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                choose: action.payload
            }
        case 'CHOOSE_ADD_VIDEO_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload
            }
        case 'CHOOSE_CANDIDATE_STATUS_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload
            }
        case 'CHOOSE_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload.message,
                chooses: [...state.chooses, action.payload.choose]
            }
        case 'CHOOSE_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'CHOOSE_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'CHOOSE_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        case 'CHOOSE_DIMISS_SUCCESS':
            return {
                ...state,
                loading: false,
                chooses: state.chooses.filter(c => c._id !== action.payload?.choose?._id),
                result: action.payload?.message
            }
        case 'CHOOSE_SCHEDULE_INTERVIEW_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload
            }
        case 'CHOOSE_SCHEDULE_LOADING':
            return {
                ...state,
                scheduleLoading: true
            }
        case 'CHOOSE_SCHEDULE_NOT_LOADING':
            return {
                ...state,
                scheduleLoading: false
            }
        case 'CHOOSE_GET_SCHEDULE_SUCCESS':
            return {
                ...state,
                scheduleLoading: false,
                schedule: action.payload || []
            }
        case 'CHOOSE_GET_SCHEDULE_QTY_SUCCESS':
            return {
                ...state,
                scheduleLoading: false,
                scheduleQty: action.payload || 0
            }
        case 'CHOOSE_REMOVE_RESULT':
            return {...state,
                result: action.payload.message,
                chooses: state.chooses.filter(chooses => chooses._id !== action.payload.chooseId)
            }
        case 'CHOOSE_OFFER_LETTER_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload
            }
        case 'CHOOSE_SET_OFFER_LETTER_RESOLUTION_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload
            }
        case 'CHOOSE_INCORPORATION_DATE_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload
            }
        case 'CHOOSE_NOTE_LOADING':
            return {
                ...state,
                noteLoading: true
            }
        case 'CHOOSE_NOTE_NOT_LOADING':
            return {
                ...state,
                noteLoading: false
            }
        case 'CHOOSE_NOTE_ADD_SUCCESS':
        case 'CHOOSE_NOTE_EDIT_SUCCESS':
            return {
                ...state,
                noteLoading: false,
                result: action.payload.message
            }
        case 'CHOOSE_CANDIDATE_HISTORY_LOADING':
            return {
                ...state,
                historyLoading: true
            }
        case 'CHOOSE_CANDIDATE_HISTORY_NOT_LOADING':
            return {
                ...state,
                historyLoading: false
            }
        case 'CHOOSE_GET_CANDIDATE_HISTORY_SUCCESS':
            return {
                ...state,
                historyLoading: false,
                history: action.payload || []
            }
        default:
            return state
    }
}

